import React, { useState, useEffect } from 'react';

const notifications = [
  { name: 'Marco D.', city: 'Milano', action: 'ha scoperto 12 incentivi compatibili', time: '2 minuti fa' },
  { name: 'Giulia F.', city: 'Roma', action: 'ha sbloccato il report personalizzato', time: '5 minuti fa' },
  { name: 'Antonio S.', city: 'Napoli', action: 'si e registrato per la verifica gratuita', time: '8 minuti fa' },
  { name: 'Francesca L.', city: 'Torino', action: 'ha caricato la visura camerale', time: '12 minuti fa' },
  { name: 'Roberto M.', city: 'Catania', action: 'ha ottenuto il report con 18 incentivi', time: '15 minuti fa' },
  { name: 'Elena P.', city: 'Firenze', action: 'ha richiesto la cessione crediti', time: '20 minuti fa' },
  { name: 'Salvatore G.', city: 'Palermo', action: 'ha scoperto 9 incentivi regionali', time: '25 minuti fa' },
  { name: 'Chiara B.', city: 'Bologna', action: 'si e registrata per la verifica gratuita', time: '30 minuti fa' },
];

export default function SocialProof() {
  const [current, setCurrent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showNotification = () => {
      const idx = Math.floor(Math.random() * notifications.length);
      setCurrent(notifications[idx]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };

    const timer = setTimeout(showNotification, 15000);
    const interval = setInterval(showNotification, 30000);

    return () => { clearTimeout(timer); clearInterval(interval); };
  }, []);

  if (!visible || !current) return null;

  return (
    <div className="social-proof" onClick={() => setVisible(false)}>
      <div style={{ fontSize: 24 }}>&#128100;</div>
      <div>
        <div className="sp-text"><strong>{current.name}</strong> da {current.city} {current.action}</div>
        <div className="sp-time">{current.time}</div>
      </div>
    </div>
  );
}
